import { MessageBar, MessageBarType } from "@fluentui/react";
import './CustomMessageAlert.css'

interface ICustomMessageAlertProps {
    message: string;
    showAlert: boolean;
    type: string;
    onDismiss?: () => void
}

export default function CustomMessageAlert(props: ICustomMessageAlertProps) {
    const renderMessageBar = () => {
        if(props.onDismiss) {
            return (
                <MessageBar
                    messageBarType={MessageBarType[props.type]}
                    isMultiline={true}
                    className="custom_message_alert"
                    onDismiss={props.onDismiss}
                    dismissButtonAriaLabel="Close"
                >
                    {props.message}
                </MessageBar>
            )
        }else {
            return (
                <MessageBar
                    messageBarType={MessageBarType[props.type]}
                    isMultiline={true}
                    className="custom_message_alert"
                >
                    {props.message}
                </MessageBar>
            )
        }
    }
    return (
        <>
            {props.showAlert && renderMessageBar()}
        </>
    );
}
